import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks/hooks";
import Table from "../../../../common/components/table";
import PageLoader from "../../../../components/PageLoader";
import { selectnexusARecordTypesListItems } from "../../../../redux/nexus-a-record-types/selector";
import { nexusARecordTypes } from "../../../../redux/nexus-a-record-types/action";

const ManagementNexusARecordTypes = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const itemsData = useSelector(selectnexusARecordTypesListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Message.Name', headerName: 'Name', sortable: true, filter: true },
      { field: 'Message.Description', headerName: 'Description' },
      { field: 'Message.DisplayOrder', headerName: 'DisplayOrder' },
    ]);
  }

  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.Message?.Id}`)
  }

  const handleDelete = (data: any) => {
    dispatch(nexusARecordTypes.delete({
      url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/nexus-management/nexus-a-record-types/delete`,
      entity: 'nexusARecordTypes',
      jsonData: {
        Records: [
          {
            "Context": {},
            "Message": {
              Id: data?.Message?.Id
            }
          }
        ]
      }
    })).then(() => {
      dispatch(nexusARecordTypes.list({
        url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/nexus-management/nexus-a-record-types/list`,
        entity: 'nexusARecordTypes',
        jsonData: {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }));
    });
  }

  const additionButtons: any = [
    {
      name: 'Add NexusARecordTypes',
      callback: () => handleAdd(),
    }
  ];

  const fetchNexusARecordTypeList = () => {
    dispatch(nexusARecordTypes.list({
      url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/nexus-management/nexus-a-record-types/list`,
      entity: 'nexusARecordTypes',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchNexusARecordTypeList()
  }, [pageData, pageSize])

  return (
    <>
      {itemsData?.isLoading ? <PageLoader /> :
        <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
          paginationData={itemsData?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete}
          additionButtons={additionButtons} headingName="Nexus-A-RecordTypes" />
      }
    </>
  );
};

export default ManagementNexusARecordTypes;




